<template>
    <div class="chart-wrapper">
        <canvas ref="chartCanvasEventos"></canvas>
    </div>
</template>

<script>
import {
    Chart,
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    Title,
    CategoryScale,
    Tooltip,
    Legend,
} from 'chart.js'

Chart.register(
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    Title,
    CategoryScale,
    Tooltip,
    Legend
)

export default {
    name: 'vistas',
    props: {
        dias: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            chart: null,
            fechasFiltradas: [],
        }
    },
    mounted() {
        this.obtenerDatos()
    },
    methods: {
        obtenerDatos() {

            const ahora = new Date()
            const fechasLimite = new Date()
            fechasLimite.setDate(ahora.getDate() - this.dias)
            axios.get(`/usuario/negocio/estadisticas/eventos`, {
                params: { dias: this.dias },
            }).then((res) => {
                const fechasUnicas = new Set()
                this.productos = res.data;
                this.productos.forEach((producto) => {
                    producto.vistas.forEach((vista) => {
                        const fecha = new Date(vista.fecha)
                        if (fecha >= fechasLimite) {
                            fechasUnicas.add(vista.fecha)
                        }
                    })
                })

                const fechasOrdenadas = Array.from(fechasUnicas).sort()
                this.fechasFiltradas = fechasOrdenadas

                const datasets = this.productos.map((producto) => {
                    const dataPorFecha = fechasOrdenadas.map((fecha) => {
                        const encontrada = producto.vistas.find((v) => v.fecha === fecha)
                        return encontrada ? encontrada.visitas : 0
                    })

                    return {
                        label: producto.nombre,
                        data: dataPorFecha,
                        borderWidth: 2,
                        tension: 0.3,
                    }
                })

                const ctx = this.$refs.chartCanvasEventos.getContext('2d')
                this.chart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: fechasOrdenadas,
                        datasets: datasets,
                    },
                    options: {
                        responsive: true,
                        plugins: {
                            legend: {
                                position: 'top',
                            },
                            tooltip: {
                                mode: 'index',
                                intersect: false,
                            },
                            title: {
                                display: true,
                                text: 'Eventos por producto',
                            },
                        },
                        interaction: {
                            mode: 'nearest',
                            axis: 'x',
                            intersect: false,
                        },
                        scales: {
                            y: {
                                beginAtZero: true,
                                title: {
                                    display: true,
                                    text: 'Eventos',
                                },
                            },
                            x: {
                                title: {
                                    display: true,
                                    text: 'Fecha',
                                },
                            },
                        },
                    },
                })
            });
        },
        filtrarDatos() {
            if (this.chart) {
                this.chart.destroy()
            }
            this.renderChart()
        },
    },
    watch: {
        dias: {
            handler: function (val, oldVal) {
                if (this.chart) {
                    this.chart.destroy()
                }
                this.obtenerDatos()
            },
            deep: true,
        },
    }
}
</script>

<style scoped>
/* ⬇️ Asegura que el canvas se adapte al contenedor */
.chart-wrapper {
    width: 100%;
    overflow-x: auto;
}

canvas {
    width: 100% !important;
    height: auto !important;
}
</style>